import { all } from 'redux-saga/effects'

import { actionSagas } from '../actions/sagas'
import { appSagas } from '../App/sagas'
import { authSagas } from '../Auth/sagas'
import { adminSagas } from '../App/Admin/sagas'
import { solutionEditorSagas } from '../App/SolutionEditor/sagas'

export function* sagas() {
    yield all([
        appSagas(),
        authSagas(),
        adminSagas(),
        actionSagas(),
        solutionEditorSagas(),
    ])
}


// WEBPACK FOOTER //
// ./src/middleware/sagas.js